import { ProductType, ProteinGroup } from 'api/foodaid/questions';

export default {
  [ProteinGroup.Poultry]: 'Poultry',
  [ProteinGroup.BeefAndVeal]: 'Beef & Veal',
  [ProteinGroup.Horse]: 'Horse',
  [ProteinGroup.Wild]: 'Game',
  [ProteinGroup.Fish]: 'Fish',
  [ProteinGroup.Lamb]: 'Lamb',
  [ProteinGroup.Goat]: 'Goat',
  [ProteinGroup.Kangaroo]: 'Kangaroo',
  [ProteinGroup.VegetarianOrVegan]: 'Vegetarian/Vegan',
  [ProductType.Dryfood]: 'Dry food',
  [ProductType.Wetfood]: ' Wet food',
  [ProductType.Barf]: ' BARF',
  [`usp-${ProteinGroup.Poultry}`]:
    '<fragment> <li> Easily digestible & low-fat</li> <li> Most popular type of meat </li> </fragment>',
  [`usp-${ProteinGroup.BeefAndVeal}`]:
    '<fragment> <li>High acceptance </li> <li>Rich in iron & phosphorus</li> </fragment> ',
  [`usp-${ProteinGroup.Horse}`]:
    '<fragment> <li>Ideal for allergy sufferers </li> <li> Particularly lean </li> </fragment> ',
  [`usp-${ProteinGroup.Wild}`]:
    '<fragment> <li>Meat from the wild </li> <li> Highly digestible</li> </fragment> ',
  [`usp-${ProteinGroup.Fish}`]:
    '<fragment> <li>Rich in natural omega-3 fatty acids </li> </fragment> ',
  [`usp-${ProteinGroup.Lamb}`]:
    '<fragment> <li>Ideal for allergy sufferers </li> <li>Particularly intense flavor </li> </fragment> ',
  [`usp-${ProteinGroup.Goat}`]:
    '<fragment> <li>Ideal for allergy sufferers </li> <li> Particularly easy to digest</li> </fragment> ',
  [`usp-${ProteinGroup.Kangaroo}`]:
    '<fragment> <li>Ideal for allergy sufferers </li> <li> Particularly easy to digest </li> </fragment> ',
  [`usp-${ProteinGroup.VegetarianOrVegan}`]:
    '<fragment> <li>For environmentally conscious furry friends </li> <li> Perfect for intolerances to animal proteins </li> </fragment> ',
};
